import { createFileRoute, redirect } from '@tanstack/react-router'

import { UserRole } from '@brickup/shared/enums'
import { requireAuth } from '@/utils/require-auth'

/** Where a role lands with no route of its own asked for. */
const HOME = {
  [UserRole.CUSTOMER]: '/customer/dashboard',
  internal: '/internal/dashboard',
} as const

/** The bare domain: whichever home the signed-in role has. */
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context, location }) => {
    const { roles } = await requireAuth(context.queryClient, location.href)

    throw redirect({
      href: roles.includes(UserRole.CUSTOMER)
        ? HOME[UserRole.CUSTOMER]
        : HOME.internal,
    })
  },
})
